var map = {
	"./accordion/accordion.vue": "./node_modules/@dreipol/vue-ui/src/components/accordion/accordion.vue",
	"./form/actions/actions.vue": "./node_modules/@dreipol/vue-ui/src/components/form/actions/actions.vue",
	"./form/checkbox/checkbox.vue": "./node_modules/@dreipol/vue-ui/src/components/form/checkbox/checkbox.vue",
	"./form/hidden/hidden.vue": "./node_modules/@dreipol/vue-ui/src/components/form/hidden/hidden.vue",
	"./form/input/input.vue": "./node_modules/@dreipol/vue-ui/src/components/form/input/input.vue",
	"./form/model-provider/model-provider.vue": "./node_modules/@dreipol/vue-ui/src/components/form/model-provider/model-provider.vue",
	"./form/optgroup/optgroup.vue": "./node_modules/@dreipol/vue-ui/src/components/form/optgroup/optgroup.vue",
	"./form/option/option.vue": "./node_modules/@dreipol/vue-ui/src/components/form/option/option.vue",
	"./form/radio/radio.vue": "./node_modules/@dreipol/vue-ui/src/components/form/radio/radio.vue",
	"./form/select/select.vue": "./node_modules/@dreipol/vue-ui/src/components/form/select/select.vue",
	"./form/textarea/textarea.vue": "./node_modules/@dreipol/vue-ui/src/components/form/textarea/textarea.vue",
	"./icon/icon.vue": "./node_modules/@dreipol/vue-ui/src/components/icon/icon.vue",
	"./intersection-observer/intersection-observer.vue": "./node_modules/@dreipol/vue-ui/src/components/intersection-observer/intersection-observer.vue",
	"./overlay/overlay.vue": "./node_modules/@dreipol/vue-ui/src/components/overlay/overlay.vue",
	"./scroll-reveal/scroll-reveal.vue": "./node_modules/@dreipol/vue-ui/src/components/scroll-reveal/scroll-reveal.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/@dreipol/vue-ui/src/components sync recursive \\.vue$";